<mat-toolbar color="primary" class="mat-elevation-z4">
    <span>Replace Instrument</span>
</mat-toolbar>
<div class="replace-instrument-container">
    <div>
        Current Instrument Serial Number: <strong>{{currentInstrumentSerialNumber}}</strong>
        <div *ngIf="lastCassettes.length > 0" class="last-cassettes-message">
            <span *ngIf="lastCassettes.length > 5">Last 5 cassettes run: {{ lastCassettes.join(', ') }}</span>
            <span *ngIf="lastCassettes.length <= 5 && lastCassettes.length > 1">Last {{ lastCassettes.length }}
                cassettes run: {{ lastCassettes.join(', ') }}</span>
            <span *ngIf="lastCassettes.length === 1">Last cassette run: {{ lastCassettes[0] }}</span>
        </div>
    </div>
    <div class="instruments-container">
        <div class="instrument-groups-container">
            <b>CC Instrument Groups:</b>
            <app-group-select [groups]="instrumentGroups" [groupIdProp]="'instrumentGroupId'"
                [groupDisplayProp]="'name'" [groupItemsProp]="'instruments'" [itemIdProp]="'instrumentId'"
                [itemDisplayProp]="'instrumentSerial'" (groupSelected)="onSelectGroup($event)"
                (itemSelected)="onSelectItem($event)" (itemRemoved)="onRemoveSelectedItem($event)" [selectedItems]="selectedInstruments" [hideGroupSelection]="true">
            </app-group-select>
            <b>Type an Instrument Serial Number:</b>
            <mat-form-field appearance="outline" class="instrument-serial-field" subscriptSizing="dynamic">
                <mat-label>Instrument Serial Number</mat-label>
                <input matInput type="text" data-testid="ic-replace-serial-input" [(ngModel)]="customSerialNumber" />
            </mat-form-field>
            <div class="button-container">
                <button mat-raised-button class="success-button" data-testid="ic-replace-add-button" (click)="onAddInstrument()">
                    <mat-icon>add</mat-icon>
                    Add
                </button>
            </div>
        </div>
        <div class="instrument-selected-container">
            <b>Instruments selected:</b>
            <div class="selected-instruments-list">
                <div *ngFor="let instrument of selectedInstruments" class="instrument-row">
                    <div class="instrument-serial-number">{{ instrument.instrumentSerial }}</div>
                    <div class="instrument-cell">
                        <button class="error" mat-icon-button [attr.data-testid]="'ic-replace-remove-button-' + instrument.instrumentSerial" (click)="removeInstrument(instrument)">
                            <mat-icon>remove_circle</mat-icon>
                        </button>
                    </div>
                    <span class="status-tag" [class.available]="instrument.hasLUTFile" [class.missing]="!instrument.hasLUTFile"
                        [matTooltip]="instrument.hasLUTFile ? 'LUT file available' : 'LUT file not found'">
                        LUT
                    </span>
                    <span class="status-tag" [class.available]="instrument.hasFactoryCalibrationFile" [class.missing]="!instrument.hasFactoryCalibrationFile"
                        [matTooltip]="instrument.hasFactoryCalibrationFile ? 'Factory Calibration file available' : 'Factory Calibration file not found'">
                        FC
                    </span>
                    <div class="instrument-cell" *ngIf="!instrument.hasLUTFile">
                        <button class="sync-device-btn" mat-raised-button color="primary"
                            [attr.data-testid]="'ic-replace-uploadlut-button-' + instrument.instrumentSerial"
                            (click)="syncDevice(instrument)">
                            Upload LUT
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="actions">
    <button mat-raised-button data-testid="ic-replace-cancel-button" (click)="cancel()">Cancel</button>
    <div class="separator"></div>
    <button mat-raised-button data-testid="ic-replace-continue-button" (click)="continue()" color="primary" [disabled]="isDisabled()">Continue</button>
</div>